/*
 * Copyright (c) 2016 Mailtech.cn, Ltd. All Rights Reserved.
 */

/**
 * dependency:
 * �����ּǣ�
 * ������ͳһ������Siosvr��websocket ���ͣ�֮���Ķ��ġ�ȡ�����ġ���Ϣ����
 *
 * 1. ϵͳ�ӿ�
 *      destroy(): ����
 *      unSubscribe(): ����
 *      subscribe(): ע����Ϣ���ͻص�������websocket ����
 *      topics: ��ע������Ϣ����
 * */

;(function(global) {

    if (global.console == null) {
        global.console = {
            log: function() {}
        };
    }
    if (console.debug == null) {
        // console.debug is non standard, but we can use this keyword to suppress some messages later
        console.debug = console.log;
    }

    var topicEnums = {
        SCANQRCODE  : '/$org_id$/onstat/mail/$tempsid$/op_app_scanqrcode',          // App��ά��ɨ����¼ | ɨ����������
        OTP_AUTH    : '/second_auth/$uid$/$tempsid$/op_app_authed_device_cert'       // Otp Auth ��¼
    };

    var op = Object.prototype;
    var oToString = op.toString;

    var bind = function(fn, ctx) {
        return function(a) {
            var l = arguments.length;
            return l
                    ? l > 1
                        ? fn.apply(ctx, arguments)
                        : fn.call(ctx, a)
                    : fn.call(ctx);
        };
    };

    var isFunction = function(it) {
        return oToString.call(it) === '[object Function]';
    };

    var noop = function() {};

    var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    var trim = function( text ) {
        return text == null ?
                "" :
                ( text + "" ).replace( rtrim, "" );
    };

    var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
    var parseJSON = function( data ) {
        // Attempt to parse using the native JSON parser first
        if ( window.JSON && window.JSON.parse ) {
            // Support: Android 2.3
            // Workaround failure to string-cast null input
            return window.JSON.parse( data + "" );
        }

        var requireNonComma,
            depth = null,
            str = trim( data + "" );

        // Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
        // after removing valid tokens
        return str && !trim( str.replace( rvalidtokens, function( token, comma, open, close ) {

            // Force termination if we see a misplaced comma
            if ( requireNonComma && comma ) {
                depth = 0;
            }

            // Perform no more replacements after returning to outermost depth
            if ( depth === 0 ) {
                return token;
            }

            // Commas must not follow "[", "{", or ","
            requireNonComma = open || comma;

            // Determine new depth
            // array/object open ("[" or "{"): depth += true - false (increment)
            // array/object close ("]" or "}"): depth += false - true (decrement)
            // other cases ("," or primitive): depth += true - true (numeric cast)
            depth += !close - !open;

            // Remove this token
            return "";
        }) ) ?
                ( Function( "return " + str ) )() :
                console.debug( "Invalid JSON: " + data );
    };

    var isSessionExpired = function(expireTime) {
        return expireTime !== -1 && new Date().getTime() > expireTime;
    };

    var Store = {
        topic: null,        // ���룬�����滻����
        observer: null,     // ����
        authMeta: {},       // ����

        host: null,         // ����
        io: null,           // ���룬socket.io ��

        maxConnTimes: 3,
        connTimes: 0,
        expireTime: -1, // siosvr����ʱsession����ʱ�䣬��ȷ������, -1 ��ʾ�޵���ʱ��

        // socket.io ����ʵ��
        socket: null,

        // ����websocket �����Ƿ������ϲ���֤�ɹ�
        isReady: false,

        _init: function(config) {
            if (config.io == null) {
                console.log('invalid io factory for websocket conn!');
                return false;
            }

            if (config.host == null) {
                console.log('invalid host for websocket conn!');
                return false;
            }

            if (config.authMeta == null) {
                console.log('invalid authMeta for websocket conn!');
                return false;
            }

            this.host = config.host;
            this.io = config.io;
            this.authMeta = config.authMeta;
            this.expireTime = config.expireTime || this.expireTime;

            this._on();
        },

        _on: function() {
            this.socket = this.io.connect(this.host, {forceNew: true});
            this.socket
                    .on('connect', bind(this._onConnect, this))
                    .on('auth_error', bind(this._onAuthError,this))
                    .on('ready', bind(this._onReady, this))
                    .on('message', bind(this._onMessage, this))
                    .on('connect_error', bind(this._onConnectError, this))
                    .on('connect_timeout', bind(this._onConnectTimeout, this))
                    .on('disconnect', bind(this._onDisconnect, this))
                    .on('reconnecting', bind(this._onReconnecting, this));
        },

        destroy: function() {
            this.unSubscribe();
        },

        subscribe: function(topic, observer, options) {
            ++Store.uid;

            if (options == null) {
                return false;
            }

            this.topic = topic;
            this.observer = isFunction(observer) ? observer : noop;

            this._init(options);
        },

        unSubscribe: function() {
            this._doUnSubscribe();
            this._destroySocket();

            delete this.tempSid;
        },

        _doUnSubscribe: function() {
            this.socket && this.socket.emit('unsubscribe',{topic: this.topic});
            delete this.topic;
            delete this.observer;
            this.authMeta = {};
        },

        _destroySocket: function() {
            this.socket && this.socket.emit('disconnect').close();

            this.socket = null;
            this.connTimes = 0;
            this.isReady = false;
        },

        _onConnect: function() {
            if (this.connTimes > this.maxConnTimes || isSessionExpired(this.expireTime)) {
                this._destroySocket();
                return false;
            }

            //this.socket.emit('auth', {
            //    clientId : 'webmail:' + this.tempSid,
            //    sid      : this.tempSid,
            //    TmpSes   : 1
            //});

            this.socket.emit('auth', this.authMeta);

            ++this.connTimes;
        },

        _onAuthError: function() {
            console.log('websocket auth error');
        },

        _onReady: function() {
            console.log('websocket ready');
            this.isReady = true;

            this.socket.emit('subscribe', {topic: this.topic});
        },

        _onMessage: function(msg) {
            console.log(msg);

            var topic = msg.topic;
            var payload = parseJSON(msg.payload);

            if (topic == this.topic) {
                this.observer(payload);
            }
        },

        _onConnectError: function(error) {
            console.log('websocket connectError: ' + error);
        },

        _onConnectTimeout: function() {
            console.log('websocket connect timeout');
        },

        _onDisconnect: function(error) {
            console.log('websocket disconnect: ' + error);
        },

        _onReconnecting: function() {
            this._onConnect();
        }
    };

    Store.topics = topicEnums;

    window.WsStore = Store;

})(typeof window !== 'undefined' ? window : this);


/*****************
 ** WEBPACK FOOTER
 ** ./web/coremail.cmxt/common/assets/@project.revision@/js/wsstore.js
 ** module id = 159
 ** module chunks = 15
 **/